import { makeActionCreator } from '../actions/actionCreators';
import { RealtimeServiceActionTypes } from '../constants';

export const tryStartRealtimeService = makeActionCreator(RealtimeServiceActionTypes.TRY_START_SERVICE)();

export type RealtimeServiceActions = ReturnType<typeof tryStartRealtimeService>;
